import React, { Component } from "react";
import CallCenterEmailSection from "./CallCenterEmailSection";
import { usStates, onlyCustomerRequestorStates } from "../assets/RequiredData";

class EmailForm extends Component {
  constructor() {
    super();
    this.state = {
      formData: {
        requestType: "",
        firstName: "",
        lastName: "",
        contactEmail: "",
        identifierType: "EMAIL_ID",
        identifierValue: "",
        requestDetails: "",
        isCaResident: "",
        appSource: "CALL CENTER EMAIL FORM",
        last4OfSsn: "",
        employeeId: "",
        storeId: "",
        address: "",
      },
      disabled: true,
      employeeReqFieldCheck: false,
      reqDetailsCount: 0,
      validType: false,
      validEmail: false,
      emailError: "",
      employeeReqFieldSSNError: "",
      employeeReqFieldEIDError: "",
      stateConfirmation: false,
      selectedReqTypeOption: "",
      selectedReqOrgOption: "",
      selectedStateOption: "",
      selectedRequestorTypeOption: "",
    };
  }
  handleStateConfirmation = (e) => {
    if (this.state.stateConfirmation === true) {
      this.setState({ stateConfirmation: false });
    } else {
      this.setState({ stateConfirmation: true });
    }
  };
  handleRequestTypeChange = (e) => {
    if (this.state.selectedRequestorTypeOption === "EMPLOYEE") {
      this.setState({ employeeReqFieldCheck: false }, () => {
        this.validationCheck();
      });
    } else {
      this.setState({ employeeReqFieldCheck: true }, () => {
        this.validationCheck();
      });
    }
    this.setState({
      selectedReqTypeOption: e.target.value,
    });
    const newFormData = { ...this.state.formData };
    if (e.target.value === "Access") {
      newFormData.requestType =
        this.state.selectedRequestorTypeOption === "CUSTOMER"
          ? this.state.selectedReqOrgOption !== "speedway"
            ? "v2_get_info_wf"
            : "v2_spdwy_get_info_wf"
          : this.state.selectedRequestorTypeOption === "EMPLOYEE" ||
            this.state.selectedRequestorTypeOption === "APPLICANT"
          ? "v2_employee_get_info_wf"
          : this.state.selectedRequestorTypeOption === "FRANCHISEE"
          ? "v2_franchisee_get_info_wf"
          : "";

      this.setState({ formData: newFormData });
    }
    if (e.target.value === "Data Deletion") {
      newFormData.requestType =
        this.state.selectedRequestorTypeOption === "CUSTOMER"
          ? this.state.selectedReqOrgOption !== "speedway"
            ? "v2_forget_me_wf"
            : "v2_spdwy_forget_me_wf"
          : this.state.selectedRequestorTypeOption === "EMPLOYEE" ||
            this.state.selectedRequestorTypeOption === "APPLICANT"
          ? "v2_employee_forget_me_wf"
          : this.state.selectedRequestorTypeOption === "FRANCHISEE"
          ? "v2_franchisee_forget_me_wf"
          : "";

      this.setState({ formData: newFormData });
    }
    if (e.target.value === "Opt-Out") {
      newFormData.requestType =
        this.state.selectedRequestorTypeOption === "CUSTOMER"
          ? "v2_optout_wf"
          : this.state.selectedRequestorTypeOption === "EMPLOYEE" ||
            this.state.selectedRequestorTypeOption === "APPLICANT"
          ? "v2_employee_opt_out_wf"
          : this.state.selectedRequestorTypeOption === "FRANCHISEE"
          ? "v2_franchisee_opt_out_wf"
          : "";

      this.setState({ formData: newFormData });
    }
    // if (e.target.value === "Restrict") {
    //   newFormData.requestType = "";
    //   this.setState({ formData: newFormData });
    // }
    this.validationCheck();
  };
  handleRequestorTypeChange = (e) => {
    this.setState({
      selectedRequestorTypeOption: e.target.value,
      selectedReqTypeOption: "",
    });
  };
  handleRequestOrgChange = (e) => {
    this.setState({
      selectedReqOrgOption: e.target.value,
      selectedReqTypeOption: "",
    });
    onlyCustomerRequestorStates.includes(this.state.selectedStateOption)
      ? this.setState({
          selectedRequestorTypeOption: "CUSTOMER",
        })
      : this.setState({
          selectedRequestorTypeOption: "",
        });
    // const newFormData = { ...this.state.formData };
    // if (e.target.value === "seven-eleven") {
    //   newFormData.requestType = "";
    //   this.setState({ formData: newFormData });
    // }
    // if (e.target.value === "speedway") {
    //   newFormData.requestType = "";
    //   this.setState({ formData: newFormData });
    // }
    // // if (e.target.value === "both") {
    // //   newFormData.requestType = "";
    // //   this.setState({ formData: newFormData });
    // // }
    this.validationCheck();
  };

  handleStateChange = (e) => {
    this.setState({
      selectedStateOption: e.target.value,
    });
    if (onlyCustomerRequestorStates.includes(e.target.value)) {
      this.setState(
        {
          selectedRequestorTypeOption: "CUSTOMER",
          employeeReqFieldCheck: true,
        },
        () => {
          this.validationCheck();
        }
      );
    }
    // if (this.state.stateConfirmation === true) {
    //   this.setState({ stateConfirmation: false });
    // }
    // const newFormData = { ...this.state.formData };
    // if (e.target.value === "CA") {
    //   newFormData.requestType = "";
    //   this.setState({ formData: newFormData });
    // }
    // if (e.target.value === "VA") {
    //   newFormData.requestType = "";
    //   this.setState({ formData: newFormData });
    // }
    // if (e.target.value === "Others") {
    //   newFormData.requestType = "";
    //   this.setState({ formData: newFormData });
    // }
    this.validationCheck();
  };
  handleFirstNameChange = (e) => {
    const newFormData = { ...this.state.formData };
    newFormData.firstName = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
  };

  handleLastNameChange = (e) => {
    const newFormData = { ...this.state.formData };
    newFormData.lastName = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
  };

  handleEmailChange = (e) => {
    const emailPattern =
     /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    if (e.target.value.length > 0) {
      this.setState({ emailError: "" });
      if (!emailPattern.test(e.target.value)) {
        this.setState(
          { emailError: "Please enter a valid email.", validEmail: false },
          () => {
            this.validationCheck();
          }
        );
      } else {
        this.setState({ emailError: "", validEmail: true }, () => {
          this.validationCheck();
        });
      }
    } else {
      this.setState({
        emailError: "This field is required.",
        validEmail: false,
      });
    }
    const newFormData = { ...this.state.formData };
    newFormData.contactEmail = e.target.value.replace(/[\<\>]/g, "");
    newFormData.identifierValue = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
  };
  handleSSNChange = (e) => {
    const newFormData = { ...this.state.formData };
    newFormData.last4OfSsn = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
    if (
      e.target.value.length != 4 &&
      this.state.formData.employeeId.length == 0
    ) {
      this.setState(
        {
          employeeReqFieldSSNError: "This field OR employee ID is required.",
          employeeReqFieldEIDError: "",

          employeeReqFieldCheck: false,
        },
        () => {
          this.validationCheck();
        }
      );
    } else {
      this.setState(
        {
          employeeReqFieldSSNError: "",
          employeeReqFieldEIDError: "",

          employeeReqFieldCheck: true,
        },
        () => {
          this.validationCheck();
        }
      );
    }
  };
  handleEmployeeIDChange = (e) => {
    const newFormData = { ...this.state.formData };
    newFormData.employeeId = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
    if (
      e.target.value.length == 0 &&
      this.state.formData.last4OfSsn.length != 4
    ) {
      this.setState(
        {
          employeeReqFieldEIDError:
            "This field OR last four of SSN is required.",
          employeeReqFieldSSNError: "",

          employeeReqFieldCheck: false,
        },
        () => {
          this.validationCheck();
        }
      );
    } else {
      this.setState(
        {
          employeeReqFieldEIDError: "",
          employeeReqFieldSSNError: "",

          employeeReqFieldCheck: true,
        },
        () => {
          this.validationCheck();
        }
      );
    }
  };
  handleStoreNumberChange = (e) => {
    const newFormData = { ...this.state.formData };
    newFormData.storeId = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
  };
  handleAddressChange = (e) => {
    const newFormData = { ...this.state.formData };
    newFormData.address = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
  };
  handleRequestDetailsChange = (e) => {
    const newFormData = { ...this.state.formData };
    newFormData.requestDetails = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
    this.setState({ reqDetailsCount: e.target.value.length });
  };

  secondaryFun(e) {
    e.classList.add("label-button");
    e.classList.remove("label-button-selected");
  }

  validationCheck() {
    if (this.state.selectedStateOption != "Others") {
      if (
        this.state.selectedReqOrgOption != "" &&
        this.state.selectedReqTypeOption != "" &&
        this.state.selectedStateOption != "" &&
        this.state.formData.firstName.length > 0 &&
        this.state.formData.lastName.length > 0 &&
        this.state.validEmail &&
        this.state.employeeReqFieldCheck
        // && this.state.isVerified
      ) {
        if (document.getElementById("submit-button")) {
          // document.getElementById("submit-button").disabled = false;
          //set state disabled make it
          this.setState({ disabled: false });
        }
      } else {
        if (document.getElementById("submit-button")) {
          // document.getElementById("submit-button").disabled = true;
          this.setState({ disabled: true });
        }
      }
    }
  }

  onSubmitBtnClick = () => {
    if (this.state.disabled) return; // Prevent duplicate submissions
    this.setState({ disabled: true });

    if (
      this.state.selectedReqOrgOption != "" &&
      this.state.selectedReqTypeOption != "" &&
      this.state.selectedStateOption != "" &&
      // this.state.isVerified &&
      this.state.formData.firstName.length > 0 &&
      this.state.formData.lastName.length > 0 &&
      this.state.validEmail &&
      this.state.employeeReqFieldCheck
    ) {
      //if(this.state.validType && this.state.validEmail) {
      let finalFormData = JSON.parse(JSON.stringify(this.state.formData));
      finalFormData["isCaResident"] =
        this.state.selectedStateOption == "California" ? "Y" : "N";
      finalFormData["state"] = usStates[this.state.selectedStateOption];
      finalFormData["requestorType"] = this.state.selectedRequestorTypeOption;
      finalFormData["sourceType"] = this.state.selectedReqOrgOption;
      this.props.onParentAppCall(finalFormData);
    }
  };

  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <CallCenterEmailSection />
          <form className="ccpa-form position-center">
            <p className="ccpa-form-required-fields">
              All fields must be completed, unless marked (optional).
            </p>

            <div className="ccpa-form-row">
              <div className="ccpa-form-col ccpa-form-col-whole">
                <div className="ccpa-label position-left">
                  <label
                    className="select-group"
                    htmlFor="state"
                    aria-label="state"
                  >
                    Select State of Residence
                  </label>
                </div>

                <div className="ccpa-select-group margin-left-1 position-left">
                  <select
                    value={this.state.selectedStateOption}
                    onChange={this.handleStateChange}
                    className="ccpa-select"
                    name="state"
                    id="state"
                  >
                    <option
                      className="ccpa-select-option"
                      value=""
                      selected
                      disabled
                      hidden
                    >
                      --Choose here--
                    </option>

                    {Object.keys(usStates).map((usState, i) => {
                      return (
                        <option
                          key={i}
                          className="ccpa-select-option"
                          value={usState}
                        >
                          {usState}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="ccpa-message"></div>
            </div>
            {/*  Dynamic */}
            <div className="ccpa-select-group margin-left-1 margin-bottom-1 position-left">
              <input
                type="checkbox"
                id="state_confirmation"
                // value="7-Eleven"
                onChange={this.handleStateConfirmation}
                disabled={this.state.selectedStateOption === ""}
                checked={this.state.stateConfirmation == true}
              />
              <label htmlFor="state_confirmation">
                {" "}
                I certify that I am currently a resident of this state.
              </label>
            </div>
            <div className="ccpa-form-row">
              <div className="ccpa-form-col ccpa-form-col-whole">
                {this.state.stateConfirmation &&
                  onlyCustomerRequestorStates.includes(
                    this.state.selectedStateOption
                  ) && (
                    <div className="margin-bottom-1 position-left">
                      {this.state.selectedStateOption === 'Oregon' && 
                        <label className="org-consumer-pa">
                          Subject to the requirements of applicable law, including the Oregon Consumer Privacy Act, we state that we have not disclosed the personal information of any Oregon resident to a Third Party.
                      </label>}
                      <label>
                        A separate request must be submitted for each privacy
                        right request, such as delete or access, for each brand
                        (Speedway or 7-Eleven)
                      </label>
                    </div>
                  )}
                {this.state.stateConfirmation &&
                  ["California"].includes(this.state.selectedStateOption) && (
                    <div className="margin-bottom-1 position-left">
                      <label>
                        A separate request must be submitted for each privacy
                        right request, such as delete or access, for each brand
                        (Speedway or 7-Eleven) by consumer category.
                      </label>
                    </div>
                  )}
              </div>
            </div>

            {this.state.stateConfirmation &&
              (["California"].includes(this.state.selectedStateOption) ||
                onlyCustomerRequestorStates.includes(
                  this.state.selectedStateOption
                )) && (
                <div>
                  <div className="ccpa-form-row">
                    <fieldset>
                      <div className="ccpa-form-col ccpa-form-col-whole">
                        <div className="ccpa-label position-left">
                          {/* <label
                            className="radio-group"
                            htmlFor="request"
                            aria-label="request"
                          >
                            Select Request Type
                          </label> */}
                          <legend>Select Brand</legend>
                        </div>
                        <div className="ccpa-radio-input-group position-left">
                          <div className="ccpa-radio-input">
                            <input
                              type="radio"
                              id="request_7-Eleven"
                              value="seven-eleven"
                              onChange={this.handleRequestOrgChange}
                              checked={
                                this.state.selectedReqOrgOption ===
                                "seven-eleven"
                              }
                            />
                            <label htmlFor="request_7-Eleven">7-Eleven</label>
                          </div>
                          <div className="ccpa-radio-input">
                            <input
                              type="radio"
                              id="request_speedway"
                              value="speedway"
                              onChange={this.handleRequestOrgChange}
                              checked={
                                this.state.selectedReqOrgOption === "speedway"
                              }
                            />
                            <label htmlFor="request_speedway">Speedway</label>
                          </div>
                          {/* <div className="ccpa-radio-input">
                          <input
                            type="radio"
                            id="request_both"
                            value="both"
                            onChange={this.handleRequestOrgChange}
                            checked={this.state.selectedReqOrgOption === "both"}
                          />
                          <label htmlFor="request_both">Both</label>
                        </div> */}
                        </div>
                      </div>
                      <div className="ccpa-message"></div>
                    </fieldset>
                  </div>
                  <div className="ccpa-form-row">
                    <fieldset>
                      <div className="ccpa-form-col ccpa-form-col-whole">
                        <div className="ccpa-label position-left">
                          {/* <label
                            className="radio-group"
                            htmlFor="request"
                            aria-label="request"
                          >
                            Select Requestor Type
                          </label> */}
                          <legend>Select Requestor Type</legend>
                        </div>
                        <div className="ccpa-radio-input-group position-left">
                          <div className="ccpa-radio-input">
                            <input
                              type="radio"
                              id="requestor-type-customer"
                              value="CUSTOMER"
                              onChange={this.handleRequestorTypeChange}
                              checked={
                                onlyCustomerRequestorStates.includes(
                                  this.state.selectedStateOption
                                )
                                  ? "checked"
                                  : this.state.selectedRequestorTypeOption ===
                                    "CUSTOMER"
                              }
                            />
                            <label htmlFor="requestor-type-customer">
                              Customer
                            </label>
                          </div>
                          {["California"].includes(
                            this.state.selectedStateOption
                          ) && (
                            <div className="ccpa-radio-input">
                              <input
                                type="radio"
                                id="requestor-type-employee"
                                value="EMPLOYEE"
                                onChange={this.handleRequestorTypeChange}
                                checked={
                                  this.state.selectedRequestorTypeOption ===
                                  "EMPLOYEE"
                                }
                              />
                              <label htmlFor="requestor-type-employee">
                                Employee
                              </label>
                            </div>
                          )}
                          {["California"].includes(
                            this.state.selectedStateOption
                          ) && (
                            <div className="ccpa-radio-input">
                              <input
                                type="radio"
                                id="requestor-type-applicant"
                                value="APPLICANT"
                                onChange={this.handleRequestorTypeChange}
                                checked={
                                  this.state.selectedRequestorTypeOption ===
                                  "APPLICANT"
                                }
                              />
                              <label htmlFor="requestor-type-applicant">
                                Applicant
                              </label>
                            </div>
                          )}
                          {["California"].includes(
                            this.state.selectedStateOption
                          ) && (
                            <div className="ccpa-radio-input">
                              <input
                                type="radio"
                                id="requestor-type-franchisee"
                                value="FRANCHISEE"
                                onChange={this.handleRequestorTypeChange}
                                checked={
                                  this.state.selectedRequestorTypeOption ===
                                  "FRANCHISEE"
                                }
                              />
                              <label htmlFor="requestor-type-franchisee">
                                Franchisee
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="ccpa-message"></div>
                    </fieldset>
                  </div>
                  <div className="ccpa-form-row">
                    <fieldset>
                      <div className="ccpa-form-col ccpa-form-col-whole">
                        <div className="ccpa-label position-left">
                          {/* <label
                            className="radio-group"
                            htmlFor="request"
                            aria-label="request"
                          >
                            Select Request Type
                          </label> */}
                          <legend>Select Request Type</legend>
                        </div>
                        <div className="ccpa-radio-input-group position-left">
                          <div className="ccpa-radio-input">
                            <input
                              type="radio"
                              id="request_info"
                              value="Access"
                              onChange={this.handleRequestTypeChange}
                              checked={
                                this.state.selectedReqTypeOption === "Access"
                              }
                            />
                            <label htmlFor="request_info">Data Access</label>
                          </div>

                          <div className="ccpa-radio-input">
                            <input
                              type="radio"
                              id="request_deletion"
                              value="Data Deletion"
                              onChange={this.handleRequestTypeChange}
                              checked={
                                this.state.selectedReqTypeOption ===
                                "Data Deletion"
                              }
                            />
                            <label htmlFor="request_deletion">
                              Data Deletion
                            </label>
                          </div>
                          <div className="ccpa-radio-input">
                            <input
                              type="radio"
                              id="request_optout"
                              value="Opt-Out"
                              onChange={this.handleRequestTypeChange}
                              checked={
                                this.state.selectedReqTypeOption === "Opt-Out"
                              }
                            />
                            <label htmlFor="request_optout">
                              Opt-Out of Sale/Share
                            </label>
                          </div>
                          {/* <div className="ccpa-radio-input">
                          <input
                            type="radio"
                            id="request_restrict"
                            value="Restrict"
                            onChange={this.handleRequestTypeChange}
                            checked={
                              this.state.selectedReqTypeOption === "Restrict"
                            }
                          />
                          <label htmlFor="request_restrict">
                            Restrict Processing of Sensitive Data
                          </label>
                        </div> */}
                        </div>
                      </div>
                      <div className="ccpa-message"></div>
                    </fieldset>
                  </div>

                  {this.state.selectedReqTypeOption != "" &&
                    this.state.selectedRequestorTypeOption != "" &&
                    this.state.selectedReqOrgOption != "" && (
                      <div>
                        <div className="ccpa-form-row">
                          <div className="ccpa-form-col ccpa-form-col-half">
                            <div className="ccpa-label">
                              <label
                                className={
                                  this.state.formData.firstName.length > 0
                                    ? ""
                                    : "visiblity-hidden"
                                }
                                htmlFor="FirstName"
                                aria-label="First Name"
                              >
                                First Name
                              </label>
                            </div>
                            <div className="ccpa-input">
                              <input
                                type="text"
                                id="FirstName"
                                defaultValue={this.state.formData.firstName}
                                value={this.state.formData.firstName}
                                onChange={this.handleFirstNameChange}
                                placeholder="First Name"
                              />
                            </div>
                            <div className="ccpa-message"></div>
                          </div>
                          <div className="ccpa-form-col ccpa-form-col-half">
                            <div className="ccpa-label">
                              <label
                                className={
                                  this.state.formData.lastName.length > 0
                                    ? ""
                                    : "visiblity-hidden"
                                }
                                htmlFor="LastName"
                                aria-label="Last Name"
                              >
                                Last Name
                              </label>
                            </div>
                            <div className="ccpa-input">
                              <input
                                type="text"
                                id="LastName"
                                defaultValue={this.state.formData.lastName}
                                value={this.state.formData.lastName}
                                onChange={this.handleLastNameChange}
                                placeholder="Last Name"
                              />
                            </div>
                            <div className="ccpa-message"></div>
                          </div>
                        </div>
                        <div className="ccpa-form-row">
                          <div className="ccpa-form-col ccpa-form-col-half">
                            <div className="ccpa-label">
                              <label
                                className={
                                  this.state.formData.contactEmail.length > 0
                                    ? ""
                                    : "visiblity-hidden"
                                }
                                htmlFor="EmailAddress"
                                aria-label="Email Address"
                              >
                                Contact Email
                              </label>
                            </div>
                            <div className="ccpa-input">
                              <input
                                type="text"
                                id="EmailAddress"
                                defaultValue={this.state.formData.contactEmail}
                                value={this.state.formData.contactEmail}
                                onChange={this.handleEmailChange}
                                placeholder="Email address that we can use to contact you"
                              />
                            </div>
                            <div className="ccpa-message">
                              <p role="alert" className="ccpa-error">
                                {this.state.emailError}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="ccpa-form-row">
                          <div className="ccpa-form-col ccpa-form-col-half">
                            <div className="ccpa-label">
                              <label
                                className={
                                  this.state.formData.requestDetails.length > 0
                                    ? ""
                                    : "visiblity-hidden"
                                }
                                htmlFor="RequestDetails"
                                aria-label="Request Details"
                              >
                                Request Details
                              </label>
                            </div>
                            <div className="ccpa-textarea">
                              <textarea
                                id="RequestDetails"
                                maxLength="5000"
                                defaultValue={
                                  this.state.formData.requestDetails
                                }
                                value={this.state.formData.requestDetails}
                                onChange={this.handleRequestDetailsChange}
                                placeholder="Request Details (Optional)"
                              />
                            </div>
                            <div
                              id="requestDetails_lengthCount"
                              className="position-right"
                            >
                              <span> {this.state.reqDetailsCount}</span>
                              <span>/5000</span>
                            </div>
                            <div className="ccpa-message"></div>
                          </div>
                        </div>
                        <div className="ccpa-form-row">
                          {["EMPLOYEE"].includes(
                            this.state.selectedRequestorTypeOption
                          ) && (
                            <div className="ccpa-form-col ccpa-form-col-whole">
                              <p className="ccpa-form-employee-required-fields">
                                Please provide EITHER last 4 of SSN or Employee
                                ID below
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="ccpa-form-row">
                          {["EMPLOYEE"].includes(
                            this.state.selectedRequestorTypeOption
                          ) && (
                            <div className="ccpa-form-col ccpa-form-col-whole margin-top-1">
                              <div className="ccpa-label">
                                <label
                                  className={
                                    this.state.formData.last4OfSsn.length > 0
                                      ? ""
                                      : "visiblity-hidden"
                                  }
                                  htmlFor="SSN"
                                  aria-label="SSN"
                                >
                                  Last 4 of SSN
                                </label>
                              </div>
                              <div className="ccpa-input">
                                <input
                                  type="number"
                                  onInput={(e) =>
                                    (e.target.value = e.target.value.slice(
                                      0,
                                      4
                                    ))
                                  }
                                  id="SSN"
                                  defaultValue={this.state.formData.last4OfSsn}
                                  // maxlength={4}
                                  value={this.state.formData.last4OfSsn}
                                  onChange={this.handleSSNChange}
                                  placeholder="Last 4 of SSN"
                                />
                              </div>
                              <div className="ccpa-message">
                                <p role="alert" className="ccpa-error">
                                  {this.state.employeeReqFieldSSNError}
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="ccpa-form-row">
                          {["EMPLOYEE"].includes(
                            this.state.selectedRequestorTypeOption
                          ) && (
                            <div className="ccpa-form-col ccpa-form-col-whole margin-top-1">
                              <label>OR</label>
                            </div>
                          )}
                        </div>
                        <div className="ccpa-form-row">
                          {["EMPLOYEE"].includes(
                            this.state.selectedRequestorTypeOption
                          ) && (
                            <div className="ccpa-form-col ccpa-form-col-whole margin-top-1">
                              <div className="ccpa-label">
                                <label
                                  className={
                                    this.state.formData.employeeId.length > 0
                                      ? ""
                                      : "visiblity-hidden"
                                  }
                                  htmlFor="EmployeeID"
                                  aria-label="Employee ID"
                                >
                                  Employee ID
                                </label>
                              </div>
                              <div className="ccpa-input">
                                <input
                                  type="text"
                                  id="EmployeeID"
                                  defaultValue={this.state.formData.employeeId}
                                  value={this.state.formData.employeeId}
                                  onChange={this.handleEmployeeIDChange}
                                  placeholder="Employee ID"
                                  maxLength={50}
                                />
                              </div>
                              <div className="ccpa-message">
                                <p role="alert" className="ccpa-error">
                                  {this.state.employeeReqFieldEIDError}
                                </p>
                              </div>
                            </div>
                          )}
                          {["FRANCHISEE"].includes(
                            this.state.selectedRequestorTypeOption
                          ) && (
                            <div className="ccpa-form-col ccpa-form-col-half">
                              <div className="ccpa-label">
                                <label
                                  className={
                                    this.state.formData.employeeId.length > 0
                                      ? ""
                                      : "visiblity-hidden"
                                  }
                                  htmlFor="StoreId"
                                  aria-label="Store ID"
                                >
                                  Store ID
                                </label>
                              </div>
                              <div className="ccpa-input">
                                <input
                                  type="text"
                                  id="StoreId"
                                  defaultValue={this.state.formData.storeId}
                                  value={this.state.formData.storeId}
                                  onChange={this.handleStoreNumberChange}
                                  placeholder="Store ID (Optional)"
                                  maxLength={100}
                                />
                              </div>
                              <div className="ccpa-message"></div>
                            </div>
                          )}
                        </div>
                        {["FRANCHISEE", "APPLICANT"].includes(
                          this.state.selectedRequestorTypeOption
                        ) && (
                          <div className="ccpa-form-row">
                            <div className="ccpa-form-col ccpa-form-col-half">
                              <div className="ccpa-label">
                                <label
                                  className={
                                    this.state.formData.address.length > 0
                                      ? ""
                                      : "visiblity-hidden"
                                  }
                                  htmlFor="Address"
                                  aria-label="Address"
                                >
                                  Address
                                </label>
                              </div>
                              <div className="ccpa-textarea">
                                <textarea
                                  id="Address"
                                  defaultValue={this.state.formData.address}
                                  value={this.state.formData.address}
                                  onChange={this.handleAddressChange}
                                  placeholder="Address (Optional)"
                                />
                              </div>

                              <div className="ccpa-message"></div>
                            </div>
                          </div>
                        )}
                        {/* <div className="ccpa-form-row">
              <div className="ccpa-form-col ccpa-form-col-half">
                <div className="ccpa-label">
                  <label>Are you a California Resident? (Optional)</label>
                </div>
                <div>
                  <span id="yes-button"
                    className="cali-res-button label-button"
                    onClick={this.handleCaResidentBtnClick}>Yes</span>
                  <span id="no-button"
                    className="cali-res-button label-button"
                    onClick={this.handleCaResidentBtnClick}>No</span>
                </div>
                <div className="ccpa-message"></div>
              </div>
              <div className="ccpa-form-col ccpa-form-col-half">
                <ReCAPTCHA
                  sitekey="6LdQM8wZAAAAAK6ePWJImuAaOY_A-3GH6HBtsn3b"
                  onChange={this.verifyCallback}
                />
              </div>
            </div> */}
                        <div className="ccpa-form-row position-center clear-both">
                          <button
                            type="button"
                            id="submit-button"
                            className="margin-top-3"
                            disabled={this.state.disabled}
                            onClick={this.onSubmitBtnClick}
                          >
                            Submit
                          </button>
                          <div className="ccpa-message"></div>
                        </div>
                      </div>
                    )}
                </div>
              )}
            {/*  End Dynamic */}

            {this.state.stateConfirmation &&
              !["California", ""].includes(this.state.selectedStateOption) &&
              !onlyCustomerRequestorStates.includes(
                this.state.selectedStateOption
              ) && (
                <div className="ccpa-form-row border-has-error  position-center clear-both">
                  <div className="ccpa-message"></div>

                  <div role="alert" className="ccpa-form-state-others">
                    For information about our privacy program and details
                    related to our practices regarding personal information of
                    consumers, including your choices regarding the use of
                    cookies and similar technologies, please see our Privacy
                    Notice at the link(s) provided above. At this time,
                    additional rights are not provided in your state of
                    residence.
                  </div>
                  <div className="ccpa-message"></div>
                </div>
              )}
          </form>
        </div>
      </div>
    );
  }
}

export default EmailForm;
